module.exports = __webpack_public_path__ + "img/logo.f1ebcac0.png";